import { render, staticRenderFns } from "./guideControl.vue?vue&type=template&id=882dc8fc&scoped=true&"
import script from "./guideControl.vue?vue&type=script&lang=js&"
export * from "./guideControl.vue?vue&type=script&lang=js&"
import style0 from "./guideControl.vue?vue&type=style&index=0&id=882dc8fc&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "882dc8fc",
  null
  
)

export default component.exports